/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface UserLockoutInfo
 */
export interface UserLockoutInfo {
    /**
     * 
     * @type {boolean}
     * @memberof UserLockoutInfo
     */
    userIsLockedOut?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserLockoutInfo
     */
    lockOutEnabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserLockoutInfo
     */
    failedAccessAttempts?: number;
    /**
     * 
     * @type {number}
     * @memberof UserLockoutInfo
     */
    maxFailedAccessAttempts?: number;
    /**
     * 
     * @type {number}
     * @memberof UserLockoutInfo
     */
    lockoutDurationSeconds?: number;
    /**
     * 
     * @type {string}
     * @memberof UserLockoutInfo
     */
    $type?: UserLockoutInfoTypeEnum;
}


/**
 * @export
 */
export const UserLockoutInfoTypeEnum = {
    PtwPtw100AppZeroCoreAuthorizationUsersUserLockoutInfoPtwPtw100AppZeroCore: 'Ptw.Ptw100.AppZero.Core.Authorization.Users.UserLockoutInfo, Ptw.Ptw100.AppZero.Core'
} as const;
export type UserLockoutInfoTypeEnum = typeof UserLockoutInfoTypeEnum[keyof typeof UserLockoutInfoTypeEnum];


/**
 * Check if a given object implements the UserLockoutInfo interface.
 */
export function instanceOfUserLockoutInfo(value?: unknown): value is UserLockoutInfo {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(UserLockoutInfoTypeEnum)[0];
}

export function UserLockoutInfoFromJSON(json: any): UserLockoutInfo {
    return UserLockoutInfoFromJSONTyped(json, false);
}

export function UserLockoutInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserLockoutInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userIsLockedOut': !exists(json, 'userIsLockedOut') ? undefined : json['userIsLockedOut'],
        'lockOutEnabled': !exists(json, 'lockOutEnabled') ? undefined : json['lockOutEnabled'],
        'failedAccessAttempts': !exists(json, 'failedAccessAttempts') ? undefined : json['failedAccessAttempts'],
        'maxFailedAccessAttempts': !exists(json, 'maxFailedAccessAttempts') ? undefined : json['maxFailedAccessAttempts'],
        'lockoutDurationSeconds': !exists(json, 'lockoutDurationSeconds') ? undefined : json['lockoutDurationSeconds'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function UserLockoutInfoToJSON(value?: UserLockoutInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'userIsLockedOut': value.userIsLockedOut,
        'lockOutEnabled': value.lockOutEnabled,
        'failedAccessAttempts': value.failedAccessAttempts,
        'maxFailedAccessAttempts': value.maxFailedAccessAttempts,
        'lockoutDurationSeconds': value.lockoutDurationSeconds,
        '$type': value.$type,
    });
}

